import {wsUrl} from '@/config/env'
import store from "@/store"

function formatParams (params = {}) {
    let arrParam = []
    Object.keys(params).forEach(key => {
        arrParam.push(`${key}=${params[key]}`)
    });
    let strParam = arrParam.join('&')
    if (strParam)
        strParam = `?${strParam}`
    return strParam
}

/**
 * 实验排队WS
 * @param labExpUid 课堂实验uid
 * @returns {string} websocket url
 */
export const getLineupUrl = (labExpUid) => {
    let token = store.getters.token
    let strParams = formatParams(Object.assign({
        labExpUid: ""
    }, {
        labExpUid,
        token
    }))
    return `${wsUrl}/api/io/ws/lineup${strParams}`
}

/**
 * 实验WS
 * @param params
 * @returns {string}
 */
export const getExpRuningUrl = (params = {}) => {
    let token = store.getters.token
    // ticket=26c2f164070d4b6c8a10761621d77d0b&GUAC_WIDTH=800&GUAC_HEIGHT=600&GUAC_DPI=72
    let strParams = formatParams(Object.assign({
        ticket: "",
        GUAC_WIDTH: 1920,
        GUAC_HEIGHT: 1080,
        GUAC_DPI: 1
    }, params, {
        token
    }))
    return `${wsUrl}/api/io/ws/exp${strParams}`
}

/**
 * 创建WebSocket连接
 * @param url WebSocket URL
 * @returns {WebSocket}
 */
export default (url) => {
    // let token = store.getters.token
    /**
     * WebSocket.readyState 当前WebSocket的连接状态
     * 0 CONNECTING Socket has been created. The connection is not yet open.
     * 1 OPEN The   connection is open and ready to communicate.
     * 2 CLOSING    The connection is in the process of closing.
     * 3 CLOSED     The connection is closed or couldn't be opened.
     */
    // return new WebSocket(url, [token])
    return new WebSocket(url)
}
